import React from "react";
import { Link } from "react-router-dom";

const VehicleCard = ({ vehicle }) => {
  return (
    <div className="bg-white shadow-lg rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl">
      <img 
        src={vehicle.primaryImage} 
        alt={vehicle.title} 
        className="w-full h-48 object-cover"
      />
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800">{vehicle.title}</h3>
        <p className="text-gray-600 text-sm">Condition: <span className="font-medium">{vehicle.condition}</span></p>
        <p className="text-gray-900 font-bold text-lg">{vehicle.price.toLocaleString()} Million CFA (negotiable)</p>
        
        <Link 
          to={`/collections/${vehicle.categories[0].slug.current}/${vehicle.slug.current}`} 
          className="mt-3 block bg-blue-600 text-white text-center py-2 rounded-lg hover:bg-blue-700 transition"
        >
          View Details
        </Link>
      </div>
    </div>
  );
};

export default VehicleCard;
